module.exports = require("@material-ui/core/Hidden");